export function get(url, options = {}) {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'GET',
            cache: 'no-cache',
            ...options,
        }).then(response => {
            const responseVal = getValue(response);
            if (response.status < 200 || response.status >= 300) {
                responseVal.then(value => reject(getResponseValue(value, response)));
            }
            responseVal
                .then(value =>
                    resolve({
                        data: value,
                    })
                )
                .catch(value => reject(getResponseValue(value, response)));
        });
    });
}

function getValue(response) {
    const contentType = response.headers.get('content-type');
    if (!contentType) {
        return Promise.reject({ data: 'No content type specified.' });
    }

    if (contentType.includes('application/json')) {
        return response.json();
    }

    if (contentType.includes('text/html') || contentType.includes('text/plain')) {
        return response.text();
    }

    return response.blob();
}

function getResponseValue(value, response) {
    return {
        response: value,
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        url: response.url,
    };
}

